import { FormikProps } from 'formik';
import { TextFieldNoLabel } from '../../../components/index';
import { SignUpFormProps } from '../types/sign-up-form-types';

const EmailAddressinput = ({formik} : {formik: FormikProps<SignUpFormProps>}) => {
  const inputProps = {
    value: formik.values.emailAddress,
    onChange: formik.handleChange,
    error: formik.touched.emailAddress && Boolean(formik.errors.emailAddress),
    helperText: formik.touched.emailAddress && formik.errors.emailAddress,
  }
  return (
    <TextFieldNoLabel textDesc='Email Address' name="emailAddress" inputProps={inputProps} placeholder='Enter Your Email ID' isRequired />
  )
}

export default EmailAddressinput;